import { Expose } from "class-transformer";

export class UpdateMetricDto {
  @Expose()
  name: string;

  @Expose()
  plural?: string;
}
